import { Message } from 'primereact/message';
import { useTranslation } from 'react-i18next';

import InfoIconPrimary from '../../../../../../../../assets/icons/InfoIconPrimary';

const GuidanceMessage = () => {
  const { t } = useTranslation();

  return (
    <Message
      severity='info'
      className='border-round-2xl bg-primary-100 w-full'
      content={
        <div className='flex flex-row w-full'>
          {/* Icon */}
          <div className='mr-2'>
            <InfoIconPrimary width={20} height={20} />
          </div>

          {/* Text */}
          <div className='flex flex-column'>
            <div className='text-lg font-medium mb-2 text-primary'>
              {t('productDetailsPage.tabs.permissionsTab.guidanceMessage.title')}
            </div>
            <div className='flex flex-column gap-2 text-black-alpha-90'>
              <li>{t('productDetailsPage.tabs.permissionsTab.guidanceMessage.content1')}</li>
              <li>{t('productDetailsPage.tabs.permissionsTab.guidanceMessage.content2')}</li>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default GuidanceMessage;
